import { QueryClient } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

/**
 * move it to its own file so that we can import it in multiple places
 * without causing circular dependency issues
 * e.g. we want to invalidate the query in zustand slice
 * having zustand action called reset that invalidate several queries
 * with this we can just import without causing circular dependency
 */
export const globalQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
    mutations: {
      onSuccess: (data) => {
        const response = data as AxiosResponse;
        if (response.status >= 400) {
          throw new Error(JSON.stringify(response));
        }
      },
    },
  },
});
